import type { Patient } from "@louise/medical-history/basic-info/calculateBasicInfoCompletion";

export function calculateMenstrualHealthCompletion(
  patient: Patient | null | undefined,
) {
  const menstrualHealth = (patient as any)?.obGynHistory?.menstrualHealth;

  const hasCycleStatus =
    menstrualHealth?.cycleStatus !== undefined &&
    menstrualHealth?.cycleStatus !== null;

  const hasFertileWindow =
    menstrualHealth?.awareOfFertileWindow !== undefined &&
    menstrualHealth?.awareOfFertileWindow !== null;

  const total = 2;
  const completed = (hasCycleStatus ? 1 : 0) + (hasFertileWindow ? 1 : 0);
  const percent = total > 0 ? completed / total : 0;
  const label = `${completed}/${total} answered`;

  return { percent, label, completed, total };
}
